import { Veiculo } from '@tivic-team/manager-ts/dist/fta/entities/veiculo.entity';
import { Equipamento } from '@tivic-team/manager-ts/dist/grl';
import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { VeiculoEquipamentoSituacao } from '@tivic-team/manager-ts/dist/mob/enums/veiculo-equipamento-situacao.enum';
import { VeiculoEquipamentoDTO } from 'app/model/dtos/mob/veiculo-equipamento.dto';
import { VeiculoEquipamentoService } from 'app/services/mob/veiculo-equipamento.service';
import { CustomFormBuilder } from 'app/tools/custom-form-builder';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';

@Component({
  selector: 'text-numero-serie',
  templateUrl: './text-numero-serie.component.html',
  styleUrls: ['./text-numero-serie.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNumeroSerieComponent implements OnInit {

  formGroup: FormGroup;
  
  constructor(
    private _veiculoEquipamentoService: VeiculoEquipamentoService,
    private _controlContainer: ControlContainer,
    private _dialogFactory: DialogFactory,
    private _customFormBuilder: CustomFormBuilder
  ) { }

  ngOnInit() { 
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.setControl("equipamento", this._customFormBuilder.build(Equipamento));
  }

  async onChangeIdEquipamento($event) {
    if (!$event) return;

    let veiculoEquipamentoDTO: VeiculoEquipamentoDTO = await this._veiculoEquipamentoService.getEquipamentoById($event.currentTarget.value);
    
    if(veiculoEquipamentoDTO.veiculo && veiculoEquipamentoDTO.cdVeiculo > 0 && veiculoEquipamentoDTO.stInstalacao == VeiculoEquipamentoSituacao.VINCULADO){
      this.formGroup.get("idEquipamento").reset();
      return this._dialogFactory.snack("Este equipamento já está vinculado ao veículo com placa: " + veiculoEquipamentoDTO.veiculo.nrPlaca, "OK", DialogFactory.SNACK_WARNING, { duration: 10000 });
    }
    this._customFormBuilder.update(this.formGroup, veiculoEquipamentoDTO.equipamento)
  }
}
